import { css } from '@emotion/react';
import styled from '@emotion/styled';

export const Container = styled.div`
  width: 100%;
  background-color: ${({ theme }) => theme.colors.white};
  border-radius: 8px;
  position: relative;
  padding-top: 20px;
`;

export const Actions = styled.div`
  display: flex;
  align-items: center;
  gap: 20px;
  position: absolute;
  top: 10px;
  right: 20px;
`;

const editStyles = css`
  line-height: 1;
  font-size: 12px;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const Edit = styled.a`
  ${editStyles};
`;

/**
 * The trigger that opens the BOB ID modal. A button rather than the anchor this used to be: it
 * goes nowhere, and an <a> with no href is skipped by the keyboard and announced as text.
 */
export const EditButton = styled.button`
  ${editStyles};
  padding: 0;
  border: none;
  background: none;
  cursor: pointer;
  color: ${({ theme }) => theme.colors.link};
  font-family: inherit;
`;
